import { API_DOMAIN, PROTOCOL } from "@/constants/url";
import { tenant as currentTenant } from "./tenant";
import { URL_INFO_REGEX } from "@/constants/regex";

/**
 * Function returning infos of a given potential link
 * @param {string} link 
 */
export function getLinkInfos(link) {
    const matchArray = link.match(URL_INFO_REGEX) ?? [];
    const valid = matchArray.length > 0;

    const { protocol, host, subdomains, domain, tld, port, path, params } = matchArray.groups ?? {};

    const url = `${protocol ?? 'http'}://${host}${port ? `:${port}`: ''}${path ?? ''}${params ?? ''}`;

    return {
        input: link,
        valid,
        protocol,
        host,
        subdomains: subdomains?.split('.').filter(Boolean) ?? [],
        domain,
        tld,
        port: port && parseInt(port),
        path,
        params: valid? new URL(url).searchParams: undefined,
    }
};

/**
 * This interceptor transforms any param list field to a comma separated string field.
 * @param {Record<string, unknown>} config
 * @returns 
 */
export function listParamsInterceptor({ params, ...config }) {

    if(params) {
        const paramEntries = Object.entries(params)
            .map(([key, value]) => ([
                key,
                value instanceof Array ? value.join(','): value,
            ]));
        params = Object.fromEntries(paramEntries);
    }

    return {
        ...config,
        params,
    };
}


// WEBPACK FOOTER //
// ./src/helpers/url.js